import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "homePage" }
const _hoisted_2 = { class: "searchBar" }

import { onMounted, ref } from "vue";
import AppCard from "@/components/AppCard.vue";
import API from "@/api";
import { listAppVoByPageUsingPost } from "@/api/appController";
import message from "@arco-design/web-vue/es/message";
import { REVIEW_STATUS_ENUM } from "@/constant/app";

// 初始化搜索条件（不应该被修改）

export default /*@__PURE__*/_defineComponent({
  __name: 'HomePage',
  setup(__props) {

const initSearchParams = {
  current: 1,
  pageSize: 12,
};

const searchParams = ref<API.AppQueryRequest>({
  ...initSearchParams,
});
const dataList = ref<API.AppVO[]>([]);
const total = ref<number>(0);

/**
 * 加载数据
 */
const loadData = async () => {
  const params = {
    reviewStatus: REVIEW_STATUS_ENUM.PASS,
    ...searchParams.value,
  };
  const res = await listAppVoByPageUsingPost(params);
  if (res.data.code === 0) {
    dataList.value = res.data.data?.records || [];
    total.value = res.data.data?.total || 0;
  } else {
    message.error("获取数据失败，" + res.data.message);
  }
};

/**
 * 执行搜索
 */
const doSearch = () => {
  searchParams.value = {
    ...initSearchParams,
    appName: searchParams.value.appName,
  };
  // 手动调用 loadData
  loadData();
};

/**
 * 当分页变化时，改变搜索条件，触发数据加载
 * @param page
 */
const onPageChange = (page: number) => {
  searchParams.value = {
    ...searchParams.value,
    current: page,
  };
  // 手动调用 loadData
  loadData();
};

/**
 * 监听 searchParams 变量，改变时触发数据的重新加载
 */
// 组件挂载时加载数据
onMounted(() => {
  loadData();
});

return (_ctx: any,_cache: any) => {
  const _component_a_input_search = _resolveComponent("a-input-search")!
  const _component_a_list = _resolveComponent("a-list")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_a_input_search, {
        modelValue: searchParams.value.appName,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchParams.value.appName) = $event)),
        style: { width: '320px' },
        placeholder: "寻找属于你的问卷应用",
        "button-text": "搜索",
        size: "large",
        "search-button": "",
        onSearch: doSearch,
        onKeyup: _withKeys(doSearch, ["enter"])
      }, null, 8, ["modelValue"])
    ]),
    _createVNode(_component_a_list, {
      class: "list-demo-action-layout",
      "grid-props": { gutter: [20, 20], sm: 24, md: 12, lg: 8, xl: 6 },
      bordered: false,
      data: dataList.value,
      "pagination-props": {
        pageSize: searchParams.value.pageSize,
        current: searchParams.value.current,
        total: total.value,
      },
      onPageChange: onPageChange
    }, {
      item: _withCtx(({ item }) => [
        _createVNode(AppCard, { app: item }, null, 8, ["app"])
      ]),
      _: 1
    }, 8, ["data", "pagination-props"])
  ]))
}
}

})